const KEY = 'pithias.billing-route.v1';
export function safeBillingRoute(route) {
  if (typeof route !== 'string') return null;
  const [pathname, search = ''] = route.split('?');
  if (pathname !== '/settings/invoice') return null;
  const input = new URLSearchParams(search), output = new URLSearchParams();
  const plan = input.get('planId'), cycle = input.get('cycle');
  if (['plan_multi_s','plan_multi_m','plan_multi_l'].includes(plan)) output.set('planId', plan);
  if (['monthly','annual'].includes(cycle)) output.set('cycle', cycle);
  if (input.get('purchase') === 'box') output.set('purchase', 'box');
  if (input.get('boxAddon') === 'true') output.set('boxAddon', 'true');
  const invoiceId = input.get('invoiceId');
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(invoiceId || '')) output.set('invoiceId', invoiceId);
  return pathname + (output.toString() ? '?' + output.toString() : '');
}
export function restoreBillingRoute(storage, fallback) {
  if (fallback !== '/') return fallback;
  try { return safeBillingRoute(storage.getItem(KEY)) || fallback; } catch { return fallback; }
}
export function rememberBillingRoute(storage, location) {
  try {
    const route = safeBillingRoute(location.pathname + (location.search || ''));
    if (route) storage.setItem(KEY, route);
    else storage.removeItem(KEY);
  } catch { /* Navigation must work with storage disabled. */ }
}
